module.exports = __webpack_public_path__ + "static/media/cards_off.0076b43d.svg";